/* eslint-disable react/prefer-stateless-function */
import React, { ComponentType } from 'react'
import {
  Container,
  Grid,
  Icon,
  Message,
  Segment
} from 'semantic-ui-react'
import { shouldRenderReskin2025 } from '../../constant'
import If from '../common/if'
import ReveleerCoachingBox from '../ReveleerCoachingBox'

const SafeSegment = Segment as unknown as ComponentType<any>
const SafeGrid = Grid as unknown as ComponentType<any>

/**
 * Provides a component that displays an informational message informing the
 * current user that the patient they tried to view is not within Curation
 * scope. The idea here is that we need a fallback page for cases where an EMR
 * integration has initiated a launch for a patient that we do not know about
 */
function EmptyScope(): JSX.Element {
  return (
    <div className="header-padding">
      <Container>
        <SafeSegment
          attached
          className="no-margin"
        >
          <SafeGrid>
            <Grid.Row>
              <Grid.Column
                mobile={ 16 }
                tablet={ 16 }
                computer={ 16 }
              >
                <If isTrue={ !shouldRenderReskin2025 }>
                  <Message
                    warning
                    icon
                  >
                    <Icon name="info circle" />
                    <Message.Content>
                      <Message.Header />
                      <div>
                        This patient is not currently in scope for Curation Health.
                      </div>
                    </Message.Content>
                  </Message>
                </If>
                <If isTrue={ shouldRenderReskin2025 }>
                  <ReveleerCoachingBox
                    coachingBoxType="infoNegative"
                    isShowing
                    message={
                      <p>
                        This patient is not currently in scope for Curation Health.
                      </p>
                    }
                  />
                </If>
              </Grid.Column>
            </Grid.Row>
          </SafeGrid>
        </SafeSegment>
      </Container>
    </div>
  )
}

export default EmptyScope
